module.exports = __webpack_public_path__ + "ede7b09a290d1f254f98ce4b8b6d7314.svg";